// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1V8e5"};